import { breakpoints } from './breakpoints';
import { fontSizes } from './fontSizes';
import { fontWeight } from './fontWeight';
import { gradients } from './gradients';
import { opacity } from './opacity';
import { radius } from './radius';
import { shadow } from './shadows';
import { spacing } from './spacing';

export default {
  opacity,
  shadow,
  radius,
  breakpoints,
  fontSizes,
  fontWeight,
  spacing,
  gradients,
};
